export enum TrackingEventName {
  ERROR = "error",
}
